import React, { useState, useEffect, useCallback } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  CampaignObject,
  Character,
  CharacterItem,
  CharacterSpell,
  Item,
  PseudoItem,
  SummonOption2,
} from "@dndModels";
import { ModelBase, PlayerObject } from "@models";
import { 
  DataType, 
  isDataType, 
  isItemType, 
  isProficiencyType, 
  ItemType, 
  ProficiencyType 
} from '@dndModels/Types';

import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import DataUtilities from '@dndUtilities/data_utilities';
import CommonUtilities from '@utilities/common_utilities';
import DandDAPI from "@dndUtilities/system_api";

import LoadingBox from "@components/input/LoadingBox";
import FilterBox from "@dndComponents/filtering/FilterBox";
import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import LetterLinks from "@components/Navigation/LetterLinks";
import PageLinks from "@components/Navigation/PageLinks";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";
import ListOptionsRow from './ListOptionsRow';

interface Props {
  data_type: DataType | ItemType | ProficiencyType | "char_spell" | "PseudoItem" | "special";
  filter?: any;
  // extra_filter?: (o: ModelBase | CharacterSpell | CharacterItem) => boolean;
  use_objects?: ModelBase[] | PlayerObject[] | CampaignObject[] | CharacterSpell[] | CharacterItem[] | SummonOption2[] | PseudoItem[];
  id_field?: string;
  change_time?: number;
  quick_fields?: string[];
  filter_on_change?: boolean;
  no_filter?: boolean;
  onChange?: (changed: string[]) => void;
  getName?: (obj: ModelBase | PlayerObject | CampaignObject | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem) => string;
  sort?: (obj1: ModelBase | PlayerObject | CampaignObject | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem, obj2: ModelBase | PlayerObject | CampaignObject | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem) => number;
  onLoadedFilter?: (objects: ModelBase[] | PlayerObject[] | CampaignObject[]) => any;
  log_it?: boolean;
  onSelect: (obj: ModelBase | PlayerObject | CampaignObject | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem) => void;
  onDelete: (obj: ModelBase | PlayerObject | CampaignObject | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem) => void;
}

const api = DandDAPI.getInstance();
const common_util = CommonUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const data_util = DataUtilities.getInstance();

export default function ListOptionsInput({
  data_type,
  filter: true_filter,
  use_objects,
  id_field = "_id",
  change_time = 0,
  quick_fields,
  filter_on_change = false,
  no_filter = false,
  getName,
  sort,
  onLoadedFilter,
  log_it = false,
  onSelect,
  onDelete
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [reloading_filter, setReloadingFilter] = useState(false);
  const [filtering, setFiltering] = useState(false);
  // const [true_filter, setTrueFilter] = useState<any>({ });
  const [objects, setObjects] = useState<ModelBase[] | PlayerObject[] | CampaignObject[] | CharacterSpell[] | CharacterItem[] | SummonOption2[] | PseudoItem[]>([]);
  const [filtered, setFiltered] = useState<ModelBase[] | PlayerObject[] | CampaignObject[] | CharacterSpell[] | CharacterItem[] | SummonOption2[] | PseudoItem[]>([]);
  const [page_num, setPageNum] = useState(0);
  const [prev_startLetter, setPrevStartLetter] = useState("");
  const [startLetter, setStartLetter] = useState("");
  const [filter, setFilter] = useState<any>({ search_string: [""] });
  const [prev_change_time, setChangeTime] = useState(0);

  const load = useCallback(async () => {
    // console.log(use_objects);
    // debugger;
    if (log_it) {
      debugger;
    }
    if (use_objects && use_objects.length > 0) {
      if (onLoadedFilter && use_objects.length > 0 && use_objects[0] instanceof ModelBase) {
        const new_filter = onLoadedFilter(use_objects as ModelBase[]);
        setFilter(new_filter);
        setReloadingFilter(true);
      }
      setObjects(use_objects);
      setFiltering(true);
    } else if (isDataType(data_type)) {
      setLoading(true);
      let new_objects = await data_util.getGoodDataOfTypeAsync(data_type);
      if (log_it) {
        console.log(new_objects);
        console.log(new_objects.map(o => o.name));
        if (data_type === "item") {
          console.log(common_util.unique_array((new_objects as Item[]).map(o => o.item_type)));
        }
      }
      if (true_filter) {
        new_objects = api.filter(data_type, new_objects, true_filter);
        if (log_it) {
          console.log(true_filter);
          console.log(new_objects);
        }
      }
      // debugger;
      if (onLoadedFilter) {
        const new_filter = onLoadedFilter(new_objects);
        setFilter(new_filter);
        setReloadingFilter(true);
      }
      setObjects(new_objects);
      setFiltering(true);
      setLoading(false);
    } else if (isProficiencyType(data_type)) {
      console.log(`Proficiency Type: ${data_type}`);
    } else if (isItemType(data_type)) {
      console.log(`Item Type: ${data_type}`);
    } else {
      console.log(data_type);
    }
  }, [use_objects, data_type, log_it]);
  
  useEffect(() => {
    if (!fetched) {
      // console.log("fetched");
      setFetched(true);
      load();
    }
  }, [fetched, load]);

  useEffect(() => {
    if (startLetter !== prev_startLetter) {
      // console.log("startLetter");
      updateFilter(filter);
      setPrevStartLetter(startLetter);
    }
    // eslint-disable-next-line
  }, [startLetter, prev_startLetter, setPrevStartLetter]);

  useEffect(() => {
    if (change_time !== prev_change_time) {
      console.log("change_time");
      setChangeTime(change_time);
      if (filter_on_change) {
        load();
      } 
    }
  }, [change_time, prev_change_time, setChangeTime, load, filter_on_change]);

  useEffect(() => {
    if (filtering) {
      // console.log("filtering");
      refilter();
      setFiltering(false);
    }
    // eslint-disable-next-line
  }, [filtering]);

  useEffect(() => {
    if (reloading_filter) {
      setReloadingFilter(false);
    }
  }, [reloading_filter, setReloadingFilter]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const refilter = () => {
    // console.log("refilter");
    updateFilter(filter);
  }

  const updateFilter = (changed: any) => {
    const the_filter = {...changed};
    if (the_filter.effect_type) {
      the_filter.effect_types = the_filter.effect_type;
      delete the_filter.effect_type;
    }
    if (the_filter.attack_type) {
      the_filter.attack_types = the_filter.attack_type;
      delete the_filter.attack_type;
    }
    // console.log(objects);
    // debugger;
    let new_filtered = api.filter(data_type, objects, the_filter);
    if (startLetter !== "") {
      new_filtered = new_filtered.filter(o => o.name.startsWith(startLetter));
    }
    the_filter.vehicle = { "$in": [undefined, false] };
    // console.log(new_filtered);
    new_filtered = new_filtered.sort((a, b) => {
      if (sort) {
        return sort(a,b);
      } else {
        return char_util.getUseName(a).localeCompare(char_util.getUseName(b));
      }
    });
    setFiltered(new_filtered);
    // setReloading(true);
  }

  // console.log(objects);
  if (!fetched || loading) {
    return (<LoadingBox />);
  } else { 
    // console.log(page_num);
    // console.log(filtered);
    const height = window.innerHeight - 221;
    const page_size = window.innerWidth >= 1000 ? Math.floor(height / 36.5) : 10;
    const page_count = Math.ceil(filtered.length / page_size);
    const filtered_and_paged = filtered.slice(page_size * page_num, page_size * (page_num + 1));
    // console.log(filtered);
    // if (reloading_filter) {
    //   debugger;
    // }
    return (
      <Grid container spacing={0} direction="row">
        { (!no_filter && data_type !== "summon") &&
          <Grid size={12}>
            { !reloading_filter && 
              <FilterBox 
                data_type={data_type}
                flat
                dont_use_api
                the_filter={filter}
                quick_fields={quick_fields}
                // log_it
                onChange={(changed: any) => {
                  setPageNum(0);
                  setStartLetter("");
                  setFilter(changed);
                  updateFilter(changed);
                }}
              />
            }
          </Grid>
        }
        <Grid size={12}>
          <PageLinks selected={page_num} page_count={page_count} onChange={setPageNum} />
        </Grid>
        <Grid
          size={12}
          container
          spacing={0}
          direction="row">
          { !reloading && filtered_and_paged.sort((a,b) => { 
            return a.name < b.name ? -1 : 1;
          }).map(obj => {
            return (
              <Grid
                key={(obj as any)[id_field]}
                className="padded"
                size={{
                  xs: 12
                }}>
                <ListOptionsRow
                  obj={obj}
                  getName={getName}
                  onSelect={() => {
                    onSelect(obj);
                  }}
                  onDelete={() => {
                    onDelete(obj);
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
        <Grid size={12}>
          <PageLinks selected={page_num} page_count={page_count} onChange={setPageNum} />
        </Grid>
        <Grid size={12}>
          <LetterLinks 
            onChange={(changed: string) => {
              setPageNum(0);
              setStartLetter(changed);
              setFiltering(true);
            }} 
          />
        </Grid>
      </Grid>
    );
  }
}
